import { Modal } from '@carbon/react';
import { defineMessages, useIntl } from 'react-intl';

import sharedMessages from 'Components/utils/sharedMessages';
import { useUnsubscribeMutation } from 'api/subscriptionPlanEndpoints';

type Props = {
    onModalClose: () => void;
    confirmationModalOpen: boolean;
}

const SubscribeFreePlanModal = ({
    onModalClose,
    confirmationModalOpen,
}: Props) => {
    const intl = useIntl();
    const [unsubscribe, { isLoading }] = useUnsubscribeMutation();

    const onChangePlanToFree = async () => {
        try {
            await unsubscribe();
            onModalClose();
        } catch (e) {
            console.log('Unsubscribe failed'); // TO_DO
        }
    };

    return (
        <Modal
            open={confirmationModalOpen}
            onRequestClose={onModalClose}
            onRequestSubmit={onChangePlanToFree}
            loadingStatus={isLoading ? 'active' : undefined}
            primaryButtonDisabled={isLoading}
            danger
            modalHeading={intl.formatMessage(messages.areYouSure)}
            modalLabel={intl.formatMessage(messages.changePlan)}
            primaryButtonText={intl.formatMessage(sharedMessages.change)}
            closeButtonLabel={intl.formatMessage(sharedMessages.cancel)}
            secondaryButtonText={intl.formatMessage(sharedMessages.back)}
        />
    );
};

const messages = defineMessages({
    changePlan: {
        id: 'src.Screens.Dashboard.Subscription.SubscribeFreePlanModal.SubscribeFreePlanModal.changePlan',
        defaultMessage: 'Zmień plan na darmowy',
    },
    areYouSure: {
        id: 'src.Screens.Dashboard.Subscription.SubscribeFreePlanModal.SubscribeFreePlanModal.areYouSure',
        defaultMessage: 'Jesteś pewien, że chcesz zmienić plan na darmowy?',
    },
});

export default SubscribeFreePlanModal;
